import type { Identifier } from "ra-core";

import { EXPENSE_MESSAGES } from "./expenseRules";

/**
 * Almikia Epic EG (TASK-044): client-side check of a category name, returning
 * the Spanish message (or undefined when valid). A duplicate is a case- and
 * space-insensitive match with ANOTHER category; the data layer enforces the
 * same rule, this only gives the answer before the round trip.
 */
export function validateCategoryName(
  name: string,
  existing: ReadonlyArray<{ id: Identifier; name: string }>,
  selfId: Identifier | undefined,
): string | undefined {
  const normalized = name.trim().toLowerCase();
  if (normalized === "") return EXPENSE_MESSAGES.categoryNameRequired;
  const isDuplicate = existing.some(
    (other) =>
      String(other.id) !== String(selfId) &&
      other.name.trim().toLowerCase() === normalized,
  );
  return isDuplicate ? EXPENSE_MESSAGES.categoryDuplicate : undefined;
}
